import jwtDecode from 'jwt-decode';

/**
 * Pure check (no side effects, no redux/store import): is there a stored access token AND is
 * it past its `exp`? Returns false when there is no token (nothing to refresh) or it can't be
 * decoded. Kept in its OWN leaf module — not authStorage — so services/api/baseApi can import
 * it without pulling in the redux store (authStorage → redux/store → redux/slices → baseApi
 * would be a circular import, leaving baseApi.reducerPath undefined at store init).
 */
export const isAccessTokenExpired = (accessToken: string | null | undefined): boolean => {
  if (!accessToken) {
    return false;
  }
  try {
    const decodedJwt: { exp: number } = jwtDecode(accessToken);
    return decodedJwt.exp < Date.now() / 1000;
  } catch (_error) {
    return false;
  }
};
